const LoadingIndicator = () => {
  return (
    <div className="w-full h-[0.0625rem] bg-black overflow-hidden">
      <div className="w-full h-full bg-[#5AC4BE] animate-[loading_1s_ease-in-out_infinite]" />
    </div>
  );
};

export default LoadingIndicator;
